module.exports = __webpack_public_path__ + "img/phone-store.46a16bc5.png";